export const DEFAULT_LOCALE = 'es';
